var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "px-1 sm:px-12 py-8 font-outfit flex-1" }, [
    _c(
      "div",
      {
        staticClass:
          "flex justify-between items-center mb-4 pb-4 borderMainClientProfile",
      },
      [
        _c("h2", { staticClass: "text-lg font-normal" }, [
          _vm._v("Required Services"),
        ]),
        _c(
          "button",
          {
            staticClass:
              "px-8 py-2 text-16 rounded-full border border-secondary-black hover:bg-gray-50 focus:outline-none",
            on: {
              click: function ($event) {
                return _vm.$emit("edit")
              },
            },
          },
          [_vm._v(" Edit ")]
        ),
      ]
    ),
    _c("div", { staticClass: "grid grid-cols-2 gap-8" }, [
      _c("div", { staticClass: "flex items-start flex-wrap" }, [
        _c(
          "ul",
          { staticClass: "list-disc pl-5 space-y-1" },
          _vm._l(_vm.data.support_type, function (service, index) {
            return _c("li", { key: index, staticClass: "text-gray-400" }, [
              _vm._v(" " + _vm._s(service) + " "),
            ])
          }),
          0
        ),
      ]),
    ]),
    _c("div", { staticClass: "mt-4" }, [
      _c("div", { staticClass: "flex-1 text-16 font-medium minWContent" }, [
        _vm._v("Frequency"),
      ]),
      _c("div", { staticClass: "flex-2 text-16 font-medium text-gray-400" }, [
        _vm._v(_vm._s(_vm.data.frequency ? _vm.data.frequency : "N/A")),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }